import './style.scss';

import State from 'interfaces/state/State';
import SubscriptionListState from 'interfaces/state/SubscriptionList';
// eslint-disable-next-line
import React from 'react';
import { connect } from 'react-redux';
import { subscriptionList$ } from 'selectors/subscriptionList';
import { Plan } from '../plan';
import style from './planList.module.scss';

interface IDispatchProps { }
interface IStateProps {
  subscriptionList: SubscriptionListState['list'];
}
interface OwnProps {
  onOpenPopup: (id: string, title: string) => void;
  isAnnually: boolean;
}

interface IProps extends IDispatchProps, IStateProps, OwnProps { }

const PlanListComponent = ({ subscriptionList, onOpenPopup, isAnnually }: IProps) => {

  return (
    <div className={style.root}>
      {subscriptionList.map(plan => {
        return <Plan key={plan.product_id} plan={plan} handleSelectNewPlan={onOpenPopup} isAnnually={isAnnually as any} />;
      })}
    </div>
  );
};

const mapStateToProps = (state: State) => {
  return {
    subscriptionList: subscriptionList$(state),
  };
};
export const PlanList = connect(mapStateToProps)(PlanListComponent);
